























































import CreatePromocodeViewModel from "@models/promocodes/createPromocodeViewModel";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class CreatePromocodeComponent extends Vue {
  isLoading = false;
  get title(): string {
    return this.id ? "Редактирование промокода" : "Добавление промокода";
  }
  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }
  vm: CreatePromocodeViewModel = new CreatePromocodeViewModel();
  async created() {
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }
  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.PromoCodeService.getDetailAsync(this.id);
    this.vm.fromServerModel(res);
    this.isLoading = false;
  }
  async save() {
    const isValid = (this.$refs.validator as any).isValid();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.vm.toServerModel();
    try {
      const res = await this.$api.PromoCodeService.updateAsync(request);
      if (res) {
        this.$dialog.success("Промокод успешно обновлен");
        this.$router.back();
      }
    } catch(e) {
      this.$notification.error(e);
    }
    this.isLoading = false;
  }
}
